<template>
  <div>
    <div class="platform-buttom-list">
      <div class="bottom-button m-r-5" @click="goToIndex">
        项目管理
      </div>
      <div class="bottom-button-active">
        规则配置
      </div>
    </div>
    <div>
      <RulesSettting :projectId="id" />
    </div>
  </div>
</template>

<script>
import { projectCommonMxins } from '../../mixins/common'

// 产品管理组件
import RulesSettting from './RulesSettting.vue'

export default {
  mixins: [projectCommonMxins],
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  components: {
    RulesSettting
  },
  data () {
    return {

    }
  }
}
</script>

<style></style>
